import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3, h4, paragraphSmall } from '@helpers/typography';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled.section `
  &[data-align='center'] {
    text-align: center;
    grid-column: span 12;

    @media ${from(Device.Tablet)} {
      grid-column: 2 / span 10;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 3 / span 8;
    }

    &[data-size='lg'],
    &[data-size='sm'] {
      @media ${from(Device.Desktop)} {
        grid-column: 4 / span 6;
      }
    }
  }
`;
const commonTitleOverrides = css `
  margin-bottom: 0;
  line-height: 1.25; // ensure that the text doesn't get cut off within highlight
`;
const Title = styled(m.h2) `
  span {
    background: var(--titleHighlight, currentColor);
    background-clip: text;
    color: transparent;
    display: inline;
  }

  ${Container}[data-size='xl'] &,
  ${Container}[data-size='lg'] & {
    ${h3};
    ${commonTitleOverrides};
  }

  ${Container}[data-size='sm'] & {
    ${h4};
    ${commonTitleOverrides};
  }
`;
const Content = styled(m.div) `
  ${contentStyles};

  @media ${until(Device.TabletLarge)} {
    p,
    li {
      ${paragraphSmall}
    }

    ul:not([style*='list-style-type']) li::before {
      top: ${fluid(5, 8)};
    }
  }

  ${Container}[data-size='xl'] & {
    margin: 20px 0 0;
  }

  ${Container}[data-size='lg'] &,
  ${Container}[data-size='sm'] & {
    margin: ${fluid(8, 12)} 0 0;
  }
`;
const IntroBlockStyles = {
    Container,
    Content,
    Title,
};
export default IntroBlockStyles;
